// extracted by mini-css-extract-plugin
export default {"wrapper":"download-media-button-module--wrapper--AupYN","downloadIconEffect":"download-media-button-module--downloadIconEffect--GtvEU"};